import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { Typography, CircularProgress, Box } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import RequestsList from "./RequestList";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import { get_payment_request_list_for_client } from "../../DAL/PaymentRequest/paymentRequest";
import { useIds } from "../../hook/AdminContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function PaymentRequests() {
  const { setUpdatePaymentRequestOnNotification } = useIds();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [paymentRequestList, setPaymentRequestList] = useState([]);
  const [value, setValue] = useState(0);
  //Changing tab values
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //Getting lesson detail
  const PaymentRequestsListing = async () => {
    setIsLoading(true);
    const result = await get_payment_request_list_for_client(
      value == 0 ? "pending" : "paid"
    );
    if (result.code === 200) {
      let all_requests = [];
      result.data.map((request, index) => {
        all_requests.push({
          ...request,
          payment_request_type: value == 0 ? "pending" : "paid",
        });
      });
      setPaymentRequestList(all_requests);
      setIsLoading(false);
    } else {
      // setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
      // navigate(`/dashboard`);
    }
  };

  useEffect(() => {
    PaymentRequestsListing();
  }, [value]);

  const handlePaymentRequestDetailsOnNotification = (
    requestData,
    setList = setPaymentRequestList
  ) => {
    console.log(requestData, "requestData.update_payment_request");
    if (requestData.deleted_payment_request_id) {
      setList((prev) =>
        prev.filter(
          (item) => item._id != requestData.deleted_payment_request_id
        )
      );
      return;
    }

    if (requestData.update_payment_request) {
      setList((prev) =>
        prev.map((item) =>
          item._id === requestData.update_payment_request._id
            ? { ...item, ...requestData.update_payment_request }
            : item
        )
      );
    } else {
      if (value == 0) {
        setList((prev) => [
          ...prev,
          { ...requestData, payment_request_type: "pending" },
        ]);
      }
    }
  };

  useEffect(() => {
    // Register the function
    setUpdatePaymentRequestOnNotification((data) => {
      handlePaymentRequestDetailsOnNotification(data, setPaymentRequestList);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdatePaymentRequestOnNotification(() => {});
    };
  }, [paymentRequestList]);

  return (
    <div className="container mt-3">
      <div className="row mobile-margin display-flex">
        <div className="col-12 col-lg-6">
          <h3>Payment Requests</h3>
        </div>
        <div className="col-12 col-lg-6 text-end">
          <Tabs
            className="custom-tabs float-end"
            value={value}
            onChange={handleChange}
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab
              className="custom-tab-item"
              label={
                <div className="tab-label">
                  Pending Requests
                  {/* <span className="tab-count">{pendingRequest.length}</span> */}
                </div>
              }
              {...a11yProps(0)}
            ></Tab>
            <Tab
              className="custom-tab-item"
              label={
                <div className="tab-label">
                  Accepted Requests
                  {/* <span className="tab-count">{activeRequest.length}</span> */}
                </div>
              }
              {...a11yProps(1)}
            />
          </Tabs>
        </div>
      </div>

      <div className="row section-space">
        <div className="col-12 section-space">
          <Box sx={{ width: "100%" }} className="px-0">
            {isLoading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="50vh"
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                <TabPanel value={value} index={0}>
                  <div className="row">
                    {paymentRequestList.length > 0 ? (
                      <div className="col-12 mt-3">
                        <RequestsList data={paymentRequestList} />
                      </div>
                    ) : (
                      <RecordNotFound title="Pending Requests Not" />
                    )}
                  </div>
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <div className="row">
                    {paymentRequestList.length > 0 ? (
                      <div className="col-12 mt-3">
                        <RequestsList data={paymentRequestList} />
                      </div>
                    ) : (
                      <RecordNotFound title="Active Requests Not" />
                    )}
                  </div>
                </TabPanel>
              </>
            )}
          </Box>
        </div>
      </div>
    </div>
  );
}

export default PaymentRequests;
